export interface IState {
  user: yakkyo.ICustomer | null
  token: string | null
  shopStatus: -1 | 1 | 0 | null
}

export const SET_USER = 'SET_USER'
export const UNSET_USER = 'UNSET_USER'
export const SHOP_STATUS = 'SHOP_STATUS'
